import React, { Fragment } from "react";
import "../css/base.css";
import { Link, withRouter } from "react-router-dom";
import { signout, isAutheticated } from "../auth/helper";
const currentTab = (history, path) => {
  if (history.location.pathname === path) {
    return { color: "Green" };
  } else {
    return { color: "bisque" };
  }
};
const Baseheader = ({ history }) => (
  <div className="header">
    <nav>
      <ul className="navagation">
        <li className="Home">
          <Link style={currentTab(history, "/")} className="nav-link" to="/">
            Home
          </Link>
        </li>
        {!isAutheticated() && (
          <Fragment>
            <li className="SignUp">
              <Link
                style={currentTab(history, "/signup")}
                className="nav-link"
                to="/signup"
              >
                SignUp
              </Link>
            </li>
            <li className="SignIn">
              <Link
                style={currentTab(history, "/signin")}
                className="nav-link"
                to="/signin"
              >
                Sign In
              </Link>
            </li>
          </Fragment>
        )}
        {isAutheticated() && (
          <Fragment>
            <li className="SignOut">
              <Link
                style={currentTab(history, "/pages")}
                className="nav-link"
                to="/pages"
              >
                Pages
              </Link>
            </li>
          </Fragment>
        )}
        {isAutheticated() && (
          <li className="SignOut">
            <span
              className="nav-link"
              onClick={() => {
                signout(() => {
                  history.push("/");
                });
              }}
            >
              Signout
            </span>
          </li>
        )}
      </ul>
    </nav>
  </div>
);

export default withRouter(Baseheader);
